(function () {
  angular
    .module('kareo.ui.shared.directives.k-insurance-company-workflow', [
      'angucomplete-alt',
      'kareo.ui.shared.directives.k-enrl-electronic-payers',
      'kareo.ui.shared.modules.featureSet',
      'kareo.ui.shared.modules.data',
      'kareo.ui.shared.modules.api.enrollments-service'
    ])
    .directive('kInsuranceCompanyWorkflow', kInsuranceCompanyWorkflow)
    .run(['$templateCache', function ($templateCache) {
      $templateCache.put('k-insurance-company-workflow/autocomplete-with-create.html', require('./autocomplete-with-create.pug')());
    }]);

    function kInsuranceCompanyWorkflow() {
      return {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        restrict: 'E',
        scope: {
          onSuccess: '&',
          onCancel: '&',
          multipleInsurances: '=',
          params: '='
        },
        cssUrl: 'site.scss',
        template: require('./k-insurance-company-workflow.pug')()
      };
    }

  controller.$inject = ['featureSet', 'practice', 'ModalService', 'enrollmentsService', '$filter', '$scope', '$window'];

  function controller(featureSet, practice, ModalService, enrollmentsService, $filter, $scope, $window) {
    const vm = this;

    vm.isLoading = true;
    vm.title = 'Add Insurance';
    vm.save = save;
    vm.close = close;
    vm.isAddInsuranceFeature = true;
    vm.nonCustomPayers = [];
    vm.isPhase2Feature = false;

    init();

    $scope.$watch('vm.payers.length', () => {
      vm.nonCustomPayers = ($filter('filter')(vm.payers, {
        clearinghousePayerId: '!!'
      }));
      if (!vm.nonCustomPayers.length) {
        vm.enrollPayers = false;
      }
    });

    //----------------------

    function close(){
      vm.onCancelCallback();
    }

    function init() {
      vm.payers = [];
      featureSet.load().then((features) => {
        vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
        vm.isPhase2Feature = features['dark-feature.enrollments-upgrade-phase2']
                          || features['dark-feature.enrollments-upgrade-phase3'];
        vm.isLoading = false;
      });

      practice.get().then((result) => {
        vm.isPmEnabled = result.pmenabled;
        vm.practiceState = result.state;
      });
    }

    function save() {
      vm.savingInsuranceCompany = true;

      enrollmentsService.createInsuranceCompanies(vm.payers).then((data) => {
        vm.savingInsuranceCompany = false;
        vm.closeSuccess({
          insuranceCompanyId: data.length > 0 && data[0],
          insuranceCompanyName: vm.payers.length > 0 && vm.payers[0].name
        });
      }, () => {
        vm.savingInsuranceCompany = false;
        vm.errorCreatingCompany = true;
      });
    }

    vm.closeSuccess = function (newCompany) {
      vm.onSuccess({ company: newCompany });
      resetState();
    };

    vm.closeCancel = function () {
      vm.onCancel();
      resetState();
    };

    function resetState() {
      vm.savingInsuranceCompany = false;
      vm.errorCreatingCompany = false;
      vm.companyName = '';
    }
    
  }
})();
